// extracted by mini-css-extract-plugin
module.exports = {"root":"_6BwpU","button":"nAsb0","small":"EqEAy","large":"TPm4u","text":"_89GNo"};